import React, { useState } from 'react';
import { styled } from '@mui/system';
import { TextField, Typography, List, ListItem, ListItemText } from '@mui/material';
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
import { ref, get } from 'firebase/database';
import { db } from '../../firebase';
import image11 from '../images/image11';
import Input from '@mui/material/Input';
import AccountCircle from '@mui/icons-material/AccountCircle';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import IconButton from '@mui/material/IconButton';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import EmailIcon from '@mui/icons-material/Email';
import FullPageLoader from './FullPageLoader';
import { getCollegeName } from '../HomePage/userManagement';

const isMobile = window.innerWidth <= 600;

const MainContainer = styled('div')({
    height: '100vh',
    display: 'flex',
    '@media (max-width: 600px)': {
        flexDirection: 'column',
    },
});

const ImageHalf = styled('div')({
    flex: 1,
    background: `url(${image11})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    width: '100%',
    '@media (max-width: 600px)': {
        height: '50vh',
        backgroundSize: 'contain',
    },
});

const ContentHalf = styled('div')({
    flex: 1,
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    color: 'black',
    justifyContent: 'center',
    textAlign: 'start',
    padding: '20px',
});

const GenerateButton = styled('button')({
    marginTop: '15px',
    backgroundColor: '#2560CD',
    padding: '10px 26px',
    cursor: 'pointer',
    fontFamily: 'Poppins, sans-serif',
    fontWeight: 500,
    color: 'white',
    height: '50px',
    borderRadius: '10px',
    fontSize: '16px',
    "&:hover": {
        background: 'black',
        color: 'white',
    },
    '@media (max-width: 768px)': {
        width: '100%',
        fontSize: '14px',
    },
});

const GeneratePaleButton = styled('button')({
    marginTop: '15px',
    backgroundColor: '#2560CD',
    opacity: '0.1',
    padding: '10px 26px',
    cursor: 'pointer',
    fontFamily: 'Poppins, sans-serif',
    color: 'white',
    height: '50px',
    fontWeight: 500,
    borderRadius: '10px',
    fontSize: '16px',
});

const AccessReport = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [userId, setUserId] = useState('');
    const [reports, setReports] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [showPassword, setShowPassword] = React.useState(false);

    const handleLogin = async () => {
        const auth = getAuth();
        setLoading(true);
        setError('');

        try {
            const userCredential = await signInWithEmailAndPassword(auth, email, password);
            const user = userCredential.user;
            setUserId(user.uid);

            fetchReportDates(userId);
        } catch (err) {
            setError('Invalid email or password');
        } finally {
            setLoading(false);
        }
    };

    const fetchReportDates = async (userId) => {
        const reportsRef = ref(db, `${getCollegeName()}/Reports/` + userId);
        try {
            const snapshot = await get(reportsRef);
            if (snapshot.exists()) {
                const data = snapshot.val();
                const reportList = Object.keys(data).map((date) => ({
                    dateTaken: data[date].dateTaken,
                    downloadURL: data[date].downloadURL,
                }));
                setReports(reportList);
            } else {
                setError('No reports available');
            }
        } catch (err) {
            setError('Error fetching reports');
        }
    };

    const handleDownloadReport = (downloadURL) => {
        window.open(downloadURL, '_blank');
    };

    return (
        <MainContainer>
            {loading && <FullPageLoader />}
            <ImageHalf></ImageHalf>
            <ContentHalf>
                <Typography
                    style={{
                        fontFamily: 'Poppins, sans-serif',
                        fontSize: isMobile ? '25px' : '40px',
                        padding: '20px',
                        fontWeight: 'bold'
                    }}>
                    Vocation<span style={{ color: 'red' }}>IQ</span>
                </Typography>
                <Typography style={{
                    textDecoration: 'underline',
                    fontSize: isMobile ? '20px' : '35px',
                    textDecorationColor: 'GrayText',
                    fontFamily: 'Poppins, sans-serif'
                }}>
                    Access Report
                </Typography>
                {error && <Typography variant="danger">{error}</Typography>}
                <FormControl sx={{ m: 1 }} variant="standard">
                    <InputLabel htmlFor="input-with-icon-adornment">
                        Email
                    </InputLabel>
                    <Input
                        id="input-with-icon-adornment"
                        color="secondary"
                        size='medium'
                        label="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        style={{ width: isMobile ? 250 : 300 }}
                        startAdornment={
                            <EmailIcon position="start" style={{ padding: '5px' }}>
                                <AccountCircle />
                            </EmailIcon>
                        }
                    />
                </FormControl>
                <FormControl sx={{ m: 1 }} variant="standard">
                    <TextField
                        type={showPassword ? 'text' : 'password'}
                        variant='standard'
                        label="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        style={{ width: isMobile ? 250 : 300, height: '50px' }}
                        size='medium'
                        required
                        InputProps={{
                            endAdornment: (
                                <IconButton
                                    onClick={() => setShowPassword(!showPassword)}
                                    edge="end"
                                >
                                    {showPassword ? <Visibility /> : <VisibilityOff />}
                                </IconButton>
                            ),
                        }}
                    />
                </FormControl>

                {
                    !password ?
                        <GeneratePaleButton disabled>Access Report</GeneratePaleButton> :
                        <GenerateButton onClick={handleLogin}>Access Report</GenerateButton>
                }

                {reports.length > 0 && (
                    <div style={{ marginTop: '20px', width: '100%', maxWidth: '500px', margin: 'auto' }}>
                        <Typography
                            variant="h6"
                            style={{
                                fontFamily: 'Poppins, sans-serif',
                                fontWeight: 'bold',
                                color: '#333',
                                marginBottom: '15px',
                                textAlign: 'center',
                            }}
                        >
                            Available Reports
                        </Typography>
                        <List>
                            {reports.map((report, index) => (
                                <ListItem
                                    button
                                    key={index}
                                    onClick={() => handleDownloadReport(report.downloadURL)}
                                    style={{
                                        backgroundColor: '#f5f5f5',
                                        borderRadius: '8px',
                                        marginBottom: '10px',
                                        padding: '12px',
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                        cursor: 'pointer',
                                        transition: 'all 0.3s ease',
                                    }}
                                    onMouseOver={(e) => {
                                        e.target.style.backgroundColor = '#e0e0e0';
                                    }}
                                    onMouseOut={(e) => {
                                        e.target.style.backgroundColor = '#f5f5f5';
                                    }}
                                >
                                    <ListItemText
                                        primary={`Report for ${new Date(report.dateTaken).toLocaleDateString()}`}
                                        style={{ fontWeight: 500 }}
                                    />
                                </ListItem>
                            ))}
                        </List>
                    </div>
                )}
            </ContentHalf>
        </MainContainer>
    );
};

export default AccessReport;
